import axios from "axios";
import userServices from "../UserServices/UserServices";

const instance = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });

const CancelToken = axios.CancelToken;

instance.interceptors.response.use(
	res => Promise.resolve(res),
	error => Promise.reject(error)
);

instance.interceptors.request.use(async config => {
	const token = userServices.getAccessToken();
	config.headers.Authorization = `JWT ${token}`;

	return config;
});
export const http = {
	get: (url, options = {}) => {
		options.cancelToken = options.cancelToken || CancelToken.source().token;
		options.onDownloadProgress = options.onDownloadProgress || (() => {});
		return instance.get(url, options);
	},
	post: (url, data, options = {}) => {
		options.cancelToken = options.cancelToken || CancelToken.source().token;
		options.onDownloadProgress = options.onDownloadProgress || (() => {});
		return instance.post(url, data, options);
	},
	put: instance.put,
	delete: instance.delete
};
